/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".radio-outer[_ngcontent-%COMP%]{position:relative;display:inline-block;width:18px;height:18px;border-radius:100%;border:1px solid #979797}.radio-outer[_ngcontent-%COMP%]   .radio-inner[_ngcontent-%COMP%]{position:absolute;top:0;left:0;bottom:0;right:0;margin:auto;height:14px;width:14px;background-color:#fff;border-radius:100%}.radio-outer.selected[_ngcontent-%COMP%]   .radio-inner[_ngcontent-%COMP%]{background-color:#6fc96f}"];
export { styles as styles };
